import React from 'react';

const Logo = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}>
            <img 
                src="/logo.png" 
                alt="Logo" 
                style={{ 
                    height: 'auto',
                    maxWidth: '100%',
                    objectFit: 'contain'
                }}
            />
        </div>
    );
};

export default Logo;
